import { FieldProps } from 'formik';
import { FormControlLabel, Tooltip } from '@mui/material';
import { LabelText } from '@styles/StyledTypography';
import { StyledCheckboxGeneral } from '@styles/StyledCheckbox';

interface ICheckboxFieldOwnProps extends FieldProps {
  id?: string;
  wrap?: boolean | undefined;
  label: string;
  readOnly?: boolean;
  tooltipMessage?: string;
}

export const CheckboxField = ({
  form: _form,
  wrap,
  field: {name, value, onBlur, onChange },
  id,
  label,
  readOnly,
  tooltipMessage,
  ...props
}: ICheckboxFieldOwnProps) => (
  <FormControlLabel
    label={<LabelText wrap={wrap}>{label}</LabelText>}
    control={
      tooltipMessage ? (
        <Tooltip title={tooltipMessage}>
          <StyledCheckboxGeneral
            {...props}
            id={id || name}
            name={name}
            checked={!!value}
            onBlur={onBlur}
            {...(readOnly
              ? {}
              : {
                  onChange: (event) => {
                    onChange({
                      ...event,
                      target: {
                        ...event.target,
                        value: !value,
                        name,
                      },
                    });
                  },
                })}
          />
        </Tooltip>
      ) : (
        <StyledCheckboxGeneral
          {...props}
          id={id || name}
          name={name}
          checked={!!value}
          onBlur={onBlur}
          {...(readOnly
            ? {}
            : {
                onChange: (event) => {
                  onChange({
                    ...event,
                    target: {
                      ...event.target,
                      value: !value,
                      name,
                    },
                  });
                },
              })}
        />
      )
    }
  />
);
